import { render, staticRenderFns } from "./CalculatePriceBlockProcessingSides.vue?vue&type=template&id=119a85b2&scoped=true&"
import script from "./CalculatePriceBlockProcessingSides.vue?vue&type=script&lang=js&"
export * from "./CalculatePriceBlockProcessingSides.vue?vue&type=script&lang=js&"
import style0 from "./CalculatePriceBlockProcessingSides.vue?vue&type=style&index=0&id=119a85b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119a85b2",
  null
  
)

export default component.exports